import * as React from 'react';
import PropTypes from 'prop-types';

import CoachingConstants from 'coaching/CoachingConstants';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
// @ts-ignore
import JoinInfoPageBirthdate from './JoinInfoPageBirthdate';
// @ts-ignore
import JoinInfoPageCreateFullAccount from './JoinInfoPageCreateFullAccount';
// @ts-ignore
import JoinInfoPageParentEmail from './JoinInfoPageParentEmail';
// @ts-ignore
import JoinInfoPageRolePicker from './JoinInfoPageRolePicker';
// @ts-ignore
import JoinPageLoadingIndicator from './JoinPageLoadingIndicator';
// @ts-ignore
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
// @ts-ignore
import PromptStore from 'stores/PromptStore';
// @ts-ignore
import AuthActions from 'auth/AuthActions';
// @ts-ignore
import User from 'entities/User';
// @ts-ignore
import UserActions from 'user/UserActions';
import ToastActions from 'actions/ToastActions';
import errorLogger from 'utils/errorLogger';
import { APIErrorType } from 'reducers/toasts';
// @ts-ignore
import { isIntendedCoachingUser } from 'setup/utils/setupCriteria';

type Props = {
  onDone?: (group: Group) => void;
  params?: {
    groupCode: string;
  };
  groupCode?: string;
};

type State = {
  status: 'loading' | 'gather_info';
  user: User | null;
};

class JoinInfoPage extends React.Component<Props, State> {
  state: State = {
    status: 'loading',
    user: null,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentWillMount() {
    AuthActions.checkLoggedInAndLoadAppData().then(
      (user: User) => {
        this.setState({ status: 'gather_info', user }, () => {
          if (!this.getNextNeed()) {
            this.onGatheredEverythingNeeded();
          }
        });
      },
      () => {
        return this.context.router.push('/log_in');
      }
    );
  }

  onError(response: any) {
    ToastActions.showAPIError(response);
  }

  onGatheredEverythingNeeded = () => {
    // we want to check for this here to cover the case where a U13 user needs to connect their
    // parent (enter their parent's email) but we still want to redirect them back to coaching after
    if (isIntendedCoachingUser()) {
      this.context.router.push(CoachingConstants.COACHING_PURCHASE_REVIEW_ROUTE);
      return;
    }

    const groupCode = this.getGroupCode();

    // if there isn't a group code then we just bail out and
    // dont try to subscribe to a class.
    if (!groupCode) {
      this.context.router.push('/classes?origin=subscribed');
      return;
    }

    const onSuccess = (updatedGroup: Group) => {
      // bypass setup/subscription setup step.
      if (PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
        UserActions.loadCurrentUser();
      } else {
        PromptActions.recordDismissal(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)
          .then(() => {
            UserActions.loadCurrentUser();
          })
          .catch(errorLogger('JoinInfoPage onSuccess failed'));
      }

      // if callback in props parent will handle transition for us.
      if (this.props.onDone) {
        this.props.onDone(updatedGroup);
        return;
      }

      this.context.router.push(`/classes/${groupCode}?origin=subscribed`);
    };

    const onError = (error: APIErrorType) => {
      this.onError(error);
      this.context.router.push('/classes');
    };

    GroupActions.subscribeToGroupWithCode(groupCode).then(onSuccess, onError);
  };

  getGroupCode = () => {
    const { params, groupCode } = this.props;
    // XXX this component does too much
    return (params && params.groupCode) || groupCode || null;
  };

  getNextNeed = () => {
    const { user } = this.state;

    const needs = user ? user.getNeeds() : {};

    /* All those components must accept a onDone props
     * that return the updated user object as well as an onError prop
     * that takes in an error response object. Order matters here.
     */
    const infos = [
      { when: needs.role, Component: JoinInfoPageRolePicker },
      { when: needs.birthdate, Component: JoinInfoPageBirthdate },
      { when: needs.parent_email, Component: JoinInfoPageParentEmail },
      { when: needs.password, Component: JoinInfoPageCreateFullAccount },
    ];

    return infos.find(info => info.when === true);
  };

  updateUser = (user: User) => {
    this.setState({ user }, () => {
      if (!this.getNextNeed()) {
        this.onGatheredEverythingNeeded();
      }
    });
  };

  renderInformationGathering() {
    const need = this.getNextNeed();

    if (!need) {
      return <JoinPageLoadingIndicator />;
    }

    return <need.Component onDone={this.updateUser} onError={this.onError} />;
  }

  renderLoading() {
    return <JoinPageLoadingIndicator />;
  }

  render() {
    if (this.state.status === 'loading') {
      return this.renderLoading();
    } else if (this.state.status === 'gather_info') {
      return this.renderInformationGathering();
    }
    return null;
  }
}

export default JoinInfoPage;
